<label class="titleLabel">
    <ng-content></ng-content>
</label>
